import React from 'react';
import { observer } from 'mobx-react';
import { ImportPatientDuplicatesTemplate } from 'themes/application/import/pages';
import { setCurrentView } from 'core/utils';
import { ImportPatientDuplicatesViewStore } from 'application/import/stores';

@setCurrentView((rootStore) => new ImportPatientDuplicatesViewStore(rootStore), 'listViewStore')
@observer
class ImportPatientDuplicates extends React.Component {
    render() {
        return <ImportPatientDuplicatesTemplate {...this.props} />
    }
}

export default ImportPatientDuplicates;